import React from 'react'
import { Typography, Button, Icon, Paper } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface CancelReservationSuccessProps {
  isProfessional: boolean
  handleClose: () => void
}

export const CancelReservationSuccess: React.FC<CancelReservationSuccessProps> = ({ isProfessional, handleClose }) => {
  return (
    <S.CancelReservationSuccessWrapper>
      <Icon
        name='Check'
        color='success'
        height={50}
        width={50}
      />

      <Typography variant='header4' weight='bold' center>
        Cancelamento de reserva <br/> efetuado com sucesso!
      </Typography>

      {isProfessional && (
        <Typography variant='content2' center>
          O paciente receberá email avisando <br/> que a reserva foi cancelada.
        </Typography>
      )}

      <Paper variant='warning' customClassName='cancelReservationSuccessPaper'>
        <Typography variant='content2'>
          <b>IMPORTANTE:</b> Se no horário desta reserva cancelada havia uma ou mais consultas agendadas, elas foram canceladas automaticamente.
        </Typography>
      </Paper>

      <Button variant='contained' color='primary' onClick={handleClose}>
        FECHAR
      </Button>
    </S.CancelReservationSuccessWrapper>
  )
}